// Constants - UPPER_CASE naming convention

export const MEAL_TYPES = {
  BREAKFAST: 1,
  LUNCH: 2,
  EVENING: 3,
  DINNER: 4,
  DEFAULT: 5,
} as const

export const MEAL_TYPE_LABELS: Record<number, string> = {
  [MEAL_TYPES.BREAKFAST]: 'Breakfast',
  [MEAL_TYPES.LUNCH]: 'Lunch',
  [MEAL_TYPES.EVENING]: 'Evening',
  [MEAL_TYPES.DINNER]: 'Dinner',
  [MEAL_TYPES.DEFAULT]: 'Meal',
} as const

export const ORDER_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  PREPARING: 'preparing',
  READY: 'ready',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
} as const

export const RESERVATION_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  SEATED: 'seated',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const

export const TOAST_DURATION = {
  SHORT: 2000,
  MEDIUM: 3000,
  LONG: 5000,
} as const

export const CATEGORY_VISIBILITY = {
  QR_MENU: 'QR_MENU',
  WEB_MENU: 'WEB_MENU',
} as const

export const API_TIMEOUT = 30000 // 30 seconds
